import Manager from "./parts/Manager";
import GetApiMasterDataClass from "./parts/airplane/GetApiMasterDataClass";
import LtikeCommon from "./parts/common/LtikeCommon";
import Util from "./libs/util/Util";

class LtikeWidgetCl {
    constructor() {
        const key = "ltike-widget-ph";

        const template = document.getElementById(key);
        if(!template) return;

        this.item = [];

        const self = this;

        customElements.define(
            "ltike-widget-ph",
            class extends HTMLElement {
                constructor() {
                    super();
                    let template = document.getElementById(key);
                    let templateContent = template.content;

                    const json = JSON.parse(decodeURIComponent(this.getAttribute("data-json")));

                    const shadowRoot = this.attachShadow({ mode: "closed" });
                    shadowRoot.appendChild(templateContent.cloneNode(true));

                    for (let i = 0; i < shadowRoot.childNodes.length; i++) {
                        const child = shadowRoot.childNodes[i];
                        if(child.className === key) {
                            //console.log(child,$(child));
                            const mg = new Manager(child,json);
                            mg.onCreate();
                            mg.onLoad();
                            mg.onResize();
                            mg.onScroll(Util.getScrollY());
                            self.item.push(mg);
                        }
                    }
                }
            },
        );

        this.getApi();
    }

    async getApi(){
        await GetApiMasterDataClass.getMasterTicketData(LtikeCommon.API.TOP,()=>{
            this.item.forEach((_i)=>_i.loadTopData());
        });
    }
}
export const ota_widget_ph = new LtikeWidgetCl();
